export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=template&id=0a36f772&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details.vue?vue&type=template&id=0a36f772&scoped=true&
// module id = null
// module chunks = 